import { type AxiosResponse } from 'axios';

import store from '~/components/myoddschecker/myoc.store';

import { $http, type IHttpOptions } from '../util/$http';

class RequestService {
	private static instance: RequestService = new RequestService();

	private baseUrl: string;
	private updateServer: (key: string | string[], val: any) => void;

	constructor() {
		if (RequestService.instance) {
			throw new Error(
				"RequestService is a singleton, you can't instantiate this.",
			);
		}
		RequestService.instance = this;

		// Functions
		this.getUrl = this.getUrl.bind(this);
		this.fetchMoreNextRaces = this.fetchMoreNextRaces.bind(this);
		this.fetchMoreEvents = this.fetchMoreEvents.bind(this);

		this.baseUrl = store.getState().server.config.baseUrl;
		this.updateServer = store.getState().updateServer;
	}

	public static getInstance(): RequestService {
		return RequestService.instance;
	}

	public getUrl(url: string, data?: any): Promise<any> {
		return new Promise((resolve, reject) => {
			const options: IHttpOptions = {
				method: 'GET',
				url: this.baseUrl + url,
			};

			if (data) {
				options.params = data;
			}

			$http(options)
				.then((res: AxiosResponse) => {
					if (res.status === 200) {
						const response = res.data;
						if (response) {
							return resolve(response);
						}
						console.log(`There was no response from ${options.url}.`);
						reject();
					} else if (res.status === 204) {
						console.log(`No data available on ${options.url}.`);
						reject();
					} else {
						console.warn(
							`An error occurred while retrieving data from ${options.url}.`,
						);
						reject();
					}
				})
				.catch(error => {
					console.error(error);
					reject();
				});
		});
	}

	public fetchMoreEvents(categoryIds = [], index) {
		const options: IHttpOptions = {
			method: 'GET',
			url: `${this.baseUrl}nextup-events`,
			params: {
				categoryIds: categoryIds.toString(),
			},
		};
		$http(options)
			.then((res: AxiosResponse) => {
				const response = res.data;
				if (response) {
					const events = response.events ? response.events : [];

					const currentEvents = store.getState().server.nextUpEvents;
					currentEvents.tabs[index].events = events;

					this.updateServer('nextUpEvents', currentEvents);
				} else {
					console.log(res.status);
				}
			})
			.catch(e => {
				console.error(e);
			});
	}

	public fetchMoreNextRaces() {
		const options: IHttpOptions = {
			method: 'GET',
			url: `${this.baseUrl}racing/nextup/default`,
		};
		$http(options)
			.then((res: AxiosResponse) => {
				const response = res.data;
				if (response) {
					const events = response.data.nextUpEventsRacing
						? response.data.nextUpEventsRacing
						: [];

					const currentEvents = store.getState().server.nextUpEventsRacing;

					const allEvents = [...currentEvents, ...events];

					const dedupedEvents = allEvents.filter(
						(event, index, arr) =>
							arr.map(mapEvent => mapEvent.url).indexOf(event.url) === index,
					);

					const currentDate = Date.now();

					const filteredEvents = dedupedEvents.filter(race => {
						const raceTimestamp = new Date(race.startTime);
						return raceTimestamp.getTime() > currentDate;
					});

					this.updateServer('nextUpEventsRacing', filteredEvents);
				} else if (res.status == 204) {
					console.log('no next up events');
				} else {
					console.log('error receiving market payload');
				}
			})
			.catch(e => {
				console.error(e);
			});
	}
}

export default RequestService;
